import React from 'react';
import If from '../../../Shared/If/If';
import ToolTip from '../../../Shared/ToolTip/ToolTip';
import styles from './FundNote.module.scss';
import { PopUpPosition } from 'src/types';

export interface FundNoteProps {
  labelText: JSX.Element | string;
  labelSubText?: JSX.Element | string;
  showToolTip?: boolean;
  tipHeader?: JSX.Element | string;
  tipMessage?: JSX.Element | string;
}
export const FundNote: React.FC<FundNoteProps> = ({
  labelText,
  labelSubText,
  showToolTip = true,
  tipHeader,
  tipMessage,
}) => {
  return (
    <div
      className={
        labelSubText
          ? styles['fund-note-with-subtext']
          : styles['fund-note-without-subtext']
      }
    >
      <If test={showToolTip}>
        <div className={styles['fund-note-tooltip-container']}>
          <ToolTip
            callerText={labelText}
            header={tipHeader}
            message={tipMessage ?? <React.Fragment />}
            popOutPlacement={PopUpPosition.TOP}
          />
        </div>
      </If>
      <If test={!showToolTip}>
        <div className={styles['fund-note-label-text']}>{labelText}</div>
      </If>
      {labelSubText && (
        <div className={styles['fund-note-subtext']}>{labelSubText}</div>
      )}
    </div>
  );
};

export default FundNote;
